import React from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import { formatAmount, formatNegativeAmount } from 'src/utils/formatAmout';
import selectFormatDate from 'src/utils/selectDateFormat';
import dateFormatType from 'src/utils/dateFormatType';

const AccountingCapitalBalanceRow = ({
  period,
  rawDate,
  initialBalance,
  equipmentCost,
  initialPayment,
  monthlyPrincipal,
  contribution,
  residual,
  settlementResult,
  finalBalance
}) => {
  return (
    <TableRow hover>
      <TableCell align="center">{period}</TableCell>
      <TableCell align="center">
        {selectFormatDate(rawDate, dateFormatType.MONTH_AND_YEAR)}
      </TableCell>
      <TableCell align="center">{formatAmount(initialBalance)}</TableCell>
      <TableCell align="center">{formatAmount(equipmentCost)}</TableCell>
      <TableCell align="center">
        {formatNegativeAmount(initialPayment)}
      </TableCell>
      <TableCell align="center">
        {formatNegativeAmount(monthlyPrincipal)}
      </TableCell>
      <TableCell align="center">{formatNegativeAmount(contribution)}</TableCell>
      <TableCell align="center">{formatNegativeAmount(residual)}</TableCell>
      {/* Plain formatAmount, not formatNegativeAmount: this column does not
          subtract from the balance the way the four before it do — the
          principal on this row was already plugged down by exactly this
          amount, and the column says how much of that period's amortization
          went to results instead. Parentheses would read as a second
          subtraction of money already accounted for. */}
      <TableCell align="center">{formatAmount(settlementResult)}</TableCell>
      <TableCell align="center" sx={{ fontWeight: 'bold' }}>
        {formatAmount(finalBalance)}
      </TableCell>
    </TableRow>
  );
};

AccountingCapitalBalanceRow.propTypes = {
  period: PropTypes.number.isRequired,
  rawDate: PropTypes.string.isRequired,
  initialBalance: PropTypes.number.isRequired,
  equipmentCost: PropTypes.number,
  initialPayment: PropTypes.number,
  monthlyPrincipal: PropTypes.number,
  contribution: PropTypes.number,
  residual: PropTypes.number,
  // Only on the row where an early payoff closes the contract.
  settlementResult: PropTypes.number,
  finalBalance: PropTypes.number.isRequired
};

AccountingCapitalBalanceRow.defaultProps = {
  equipmentCost: 0,
  initialPayment: 0,
  monthlyPrincipal: 0,
  contribution: 0,
  residual: 0,
  settlementResult: 0
};

export default AccountingCapitalBalanceRow;
